import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock, ArrowRight } from 'lucide-react';

const Branches = () => {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const branches = [
    {
      name: 'Muzaffarpur',
      address: [
        'Add.1- Mehta Compound, Near Simna International Hotel, Power House Chowk, Muzaffarpur (842003), Bihar',
        'Add.2- New Sikanderpur Road, Near Gupta Timber, Akharaghat, Muzaffarpur (842001), Bihar'
      ],
      phone: '7727043497, 8797681753',
      email: 'kidsworkrehabcentre@gmail.com',
      hours: `Mon - Sat: 10:00 AM - 8:00 PM
Sun - Closed`
    },
    {
      name: 'Sitamarhi',
      address: [
        'Shanti Nagar, Near ITI College, RCM Gali, Dumra, Sitamarhi (843301), Bihar'
      ],
      phone: '7727043497, 8797681753',
      email: 'kidsworkrehabcentre@gmail.com',
      hours: `Mon - Sat: 10:00 AM - 8:00 PM
Sun - Closed`
    }
  ];

  return (
    <div className="font-sans text-[#424242] bg-gray-50 min-h-screen">
      
      {/* Header Section */}
      <div className="bg-indigo-700 py-20 px-5 text-center text-white relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-indigo-900/50 to-violet-900/50"></div>
        <div className="relative z-10 max-w-[800px] mx-auto">
          <h1 className="text-4xl md:text-6xl font-bold mb-4">Our Locations</h1>
          <p className="text-xl text-indigo-100 font-light">
            Conveniently located centers tailored for your child's needs. Visit us at a branch near you.
          </p>
        </div>
      </div>

      <div className="max-w-[1000px] mx-auto px-5 -mt-10 relative z-20 pb-20">
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          
          {branches.map((branch, index) => (
            <div
              key={index}
              className="bg-white rounded-[20px] p-8 shadow-[0_10px_30px_rgba(0,0,0,0.08)] hover:shadow-[0_20px_40px_rgba(79,70,229,0.15)] transition-all duration-300 border border-gray-100 flex flex-col group hover:-translate-y-2"
            >
              
              {/* Title */}
              <div className="flex items-center gap-4 mb-6 pb-6 border-b border-gray-100">
                <div className="w-14 h-14 bg-indigo-50 rounded-full flex items-center justify-center text-indigo-700 group-hover:bg-indigo-700 group-hover:text-white transition-colors duration-300">
                  <MapPin className="w-7 h-7" />
                </div>
                <h2 className="text-2xl font-bold text-gray-800">{branch.name}</h2>
              </div>

              {/* Info */}
              <div className="space-y-4 mb-8 flex-1">
                
                {/* Address */}
                <div className="flex items-start gap-3">
                  <MapPin className="w-5 h-5 text-gray-400 mt-1 shrink-0" />
                  <div className="text-gray-600 leading-relaxed space-y-1">
                    {branch.address.map((addr, i) => (
                      <p key={i}>{addr}</p>
                    ))}
                  </div>
                </div>

                {/* Phone */}
                <div className="flex items-center gap-3">
                  <Phone className="w-5 h-5 text-gray-400 shrink-0" />
                  <p className="text-gray-600 font-medium">{branch.phone}</p>
                </div>

                {/* Email */}
                <div className="flex items-start gap-3">
                  <Mail className="w-5 h-5 text-gray-400 shrink-0 mt-1" />
                  <p className="text-gray-600 break-all">{branch.email}</p>
                </div>

                {/* Hours */}
                <div className="flex items-start gap-3">
                  <Clock className="w-5 h-5 text-gray-400 shrink-0 mt-1" />
                  <p className="text-gray-600 whitespace-pre-line">{branch.hours}</p>
                </div>

              </div>

              {/* Button */}
              <Link
                to={`/book-online?center=${encodeURIComponent(branch.name)}`}
                className="w-full bg-indigo-700 text-white py-4 rounded-xl font-bold text-center shadow-lg hover:shadow-xl hover:bg-indigo-800 transition-all flex items-center justify-center gap-2 group-hover:gap-3"
              >
                Book Appointment <ArrowRight className="w-5 h-5" />
              </Link>

            </div>
          ))}
        </div>

        {/* Bottom Message */}
        <div className="mt-16 text-center">
          <p className="text-xl md:text-2xl font-medium text-indigo-900 border-2 border-dashed border-indigo-200 p-6 rounded-xl inline-block bg-indigo-50/50">
            Book an appointment, and we will reach out to you soon.
          </p>
        </div>

      </div>
    </div>
  );
};

export default Branches;
